import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapContainer, TileLayer, Polygon, ZoomControl } from 'react-leaflet';
import { Box, Typography } from '@mui/material';
import { getPolygonCenter } from '../../globals/utils';

const AmSatelliteTilePlotMap = ({
  // tile,
  polygon,
  // activeTile,
  MapEventsHandler,
  // setIsLoading,
  zoom = 17,
  height = '400px',
}) => {
  // Calculate center of polygon
  const center = getPolygonCenter(polygon);
  const { t } = useTranslation();

  if (!center) {
    return (
      <Box sx={{ textAlign: 'center', p: 4 }}>
        <Typography variant="body2" color="text.secondary">
          {t('No valid polygon data available to display the map.')}
        </Typography>
      </Box>
    );
  }

  return (
    <MapContainer
      zoom={zoom}
      center={[center.lat, center.lng]}
      style={{ height: height }}
      zoomControl={false}
    >
      <MapEventsHandler />
      <ZoomControl position="bottomleft" />

      {/* Satellite base layer */}
      <TileLayer
        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        attribution="Tiles &copy; Esri"
      />

      {/* OSM labels overlay */}
      <TileLayer
        url="https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap"
      />

      {/* Satellite data layer */}
      {/* {activeTile !== "none" && tile[activeTile] && (
        <TileLayer
          url={`${tile[activeTile]}&paletteid=1`}
          opacity={1}
          eventHandlers={{
            loading: () => setIsLoading(true),
            load: () => setIsLoading(false),
            error: () => setIsLoading(false),
          }}
        />
      )} */}

      {/* Field boundary polygon */}
      <Polygon
        positions={polygon}
        pathOptions={{
          color: 'red',
          weight: 4,
          fillColor: 'lightgreen',
          fillOpacity: 0.5,
        }}
        fill={true}
      />
    </MapContainer>
  );
};

export default AmSatelliteTilePlotMap;
